import { render, staticRenderFns } from "./PageBreadcrumb.vue?vue&type=template&id=bfaec6f0&scoped=true"
import script from "./PageBreadcrumb.vue?vue&type=script&lang=js"
export * from "./PageBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./PageBreadcrumb.vue?vue&type=style&index=0&id=bfaec6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaec6f0",
  null
  
)

export default component.exports